import { PolyIcon } from "elements";
import { SubnetRuleValidityResult } from "generated/graphql";
import { useTranslation } from "utilities/i18n";

export const WarningMessage: React.FC<{
  type?: { result: SubnetRuleValidityResult; siteName?: string };
}> = ({ type = { result: SubnetRuleValidityResult.Valid, siteName: "" } }) => {
  const { t } = useTranslation();

  if (type.result === SubnetRuleValidityResult.Valid) {
    return null;
  }

  let icon = "";
  let messageText = "";
  if (type.result === SubnetRuleValidityResult.Overlap) {
    icon = "warning_triangle";
    messageText = t("SUBNET_OVERLAP_WARNING", { siteName: type.siteName });
  } else if (type.result === SubnetRuleValidityResult.Duplicate) {
    icon = "minus_circle";
    messageText = type.siteName
      ? t("SUBNET_DUPLICATE_ERROR_SITE", { siteName: type.siteName })
      : t("SUBNET_DUPLICATE_ERROR");
  }

  return (
    <div className="card col-5 mb-0 grid">
      <PolyIcon
        className="white v-center pl-75"
        data-testid="subnet-message-icon"
        icon={icon}
      />
      <div className="col-11 font-xs pl-75">{messageText}</div>
    </div>
  );
};
